const LIMA_MS = -5 * 60 * 60 * 1000

export function nowLima() {
  return new Date(Date.now() + LIMA_MS)
}

export function toLima(str) {
  return new Date(new Date(str).getTime() + LIMA_MS)
}

export function formatLima(str) {
  return toLima(str).toLocaleString('es-PE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: false,
  })
}

export function formatTimeLima(str) {
  return toLima(str).toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit', hour12: false })
}

export function relativeTime(str) {
  const diff = nowLima().getTime() - toLima(str).getTime()
  const min = Math.floor(diff / 60000)
  if (min < 1)  return 'ahora'
  if (min < 60) return `hace ${min}m`
  const h = Math.floor(min / 60)
  if (h < 24)   return `hace ${h}h`
  return `hace ${Math.floor(h / 24)}d`
}

export function todayLima() {
  const d = nowLima()
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
}

/** ISO string (UTC) del inicio del día en Lima, con offset de días */
export function startOfDayLima(offsetDays = 0) {
  const d = nowLima()
  d.setDate(d.getDate() - offsetDays)
  d.setHours(0, 0, 0, 0)
  return new Date(d.getTime() - LIMA_MS).toISOString()
}

export function labelDate(dateStr) {
  const [, m, d] = dateStr.split('-')
  return `${d}/${m}`
}
